import { memo } from 'react'
import PropTypes from 'prop-types'

import { Switch } from 'basic-components'

import classNames from 'classnames'
import { When } from 'react-if'

import './ToggleRow.scss'

const ToggleRow = ({ className = undefined, disabled = false, label, name, on, onChange, text = undefined }) => (
  <div className={classNames("data-lake__group-dialog__advanced__toggle-row", className)}>
    <div className="data-lake__group-dialog__advanced__toggle-row__left">
      <div className="data-lake__group-dialog__advanced__toggle-row__left__label">{label}</div>
      <When condition={!!text}>
        {() => (
          <div className="data-lake__group-dialog__advanced__toggle-row__left__text">{text}</div>
        )}
      </When>
    </div>
    <div className="data-lake__group-dialog__advanced__toggle-row__right">
      <Switch
          disabled={disabled}
          name={name}
          on={on}
          onChange={onChange}
      />
    </div>
  </div>
)

ToggleRow.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  on: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  text: PropTypes.string
}

export default memo(ToggleRow)
